import React from "react";


const ArchitectView = (): JSX.Element => {

    return (
        <></>
    );
};


export default ArchitectView;
